import React from 'react';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';
// import HelpCenter from './HelpCenter';
// import FAQ from './FAQ';
// import AboutEnjoy from './AboutEnjoy';
// import ContactUs from './ContactUs';

const element = {
  terms: TermsOfUse,
  privacy: PrivacyPolicy
  // help: HelpCenter,
  // faq: FAQ,
  // about: AboutEnjoy,
  // contact: ContactUs,
};
const LegalDocs = _ref => {
  let {
    doc,
    ...props
  } = _ref;
  const Element = element[doc];
  return /*#__PURE__*/React.createElement(Element, props);
};
export default LegalDocs;